<script lang="ts">
	import { editable } from '$lib/storyblok/editable';
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../../blok.svelte';
	import type { SbLink, SbMuxVideo, SbResponsiveMuxVideo } from '../../types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import { slideIn } from '$lib/actions/slideIn';
	import Instagram from '$lib/icons/instagram.svelte';
	import Button from '$lib/buttons/v3/button.svelte';
	import Play from '$lib/icons/play.svelte';
	import type { CardCategory } from './types';

	interface Props {
		content: ISbStoryData<{
			link: SbLink;
			handle: string;
			video: Array<ISbStoryData<SbMuxVideo | SbResponsiveMuxVideo>>;
			category: CardCategory;
		}>['content'];
		delay?: number;
		threshold?: number;
	}

	let { content, delay = 0, threshold = 0.3 }: Props = $props();
</script>

<a
	href={getSbUrl(content.link)}
	target="_blank"
	rel="noopener noreferrer"
	class="lg:aspect=[280/372] relative block aspect-[171/230] overflow-hidden rounded-xl opacity-[0.01]"
	use:slideIn={{ delay, threshold }}
	use:editable={content}
>
	{#if content.video.length > 0}
		<Blok content={content.video[0]} />
	{/if}
	<article
		class="absolute inset-x-0 bottom-0 flex items-center justify-center gap-x-1.5 p-3 text-white lg:px-3 lg:py-6"
	>
		<Instagram class="h-6 w-6" />
		<h1 class="text-[16px]/[150%] max-lg:tracking-[-.16px]">{content.handle}</h1>
	</article>
	<div class="absolute inset-0 flex items-center justify-center">
		<Button class="btn-white"><Play /></Button>
	</div>
</a>

<style>
	article {
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);

		h1 {
			text-shadow: 0px 0px 56.093px rgba(13, 13, 5, 0.2);
		}
	}
</style>
